import { useTranslations } from "next-intl";
import { useMemo } from "react";

const timeFormatter = new Intl.DateTimeFormat(undefined, {
  hour: "numeric",
  hourCycle: "h12",
  minute: "2-digit",
});

export const useProductDispatchInfo = ({ cutOffDate }: { cutOffDate?: Date | string | null }) => {
  const t = useTranslations("common");

  const orderCompletionTime = useMemo(() => {
    if (!cutOffDate) return "";

    const cutOffDateParsed = cutOffDate instanceof Date ? cutOffDate : new Date(cutOffDate);
    const isCurrentDayCutOff =
      cutOffDateParsed.toISOString().split("T")[0] === new Date().toISOString().split("T")[0];
    const formattedHour = timeFormatter.format(cutOffDateParsed);

    return `${formattedHour} ${t(isCurrentDayCutOff ? "text-today" : "text-tomorrow")}`;
  }, [cutOffDate]);

  return { orderCompletionTime };
};
